import type { QueryClient } from "@tanstack/react-query";

/**
 * Checks if a query key contains specific filter values
 * @param queryKey - The query key to check
 * @param filters - Object with filter key-value pairs to match
 * @returns true if the query key contains all specified filters
 */
export const hasQueryKeyFilter = (
  queryKey: readonly unknown[],
  filters: Record<string, unknown>,
): boolean => {
  return Object.entries(filters).every(([key, value]) =>
    queryKey.some(
      (queryPart) =>
        typeof queryPart === "object" &&
        queryPart !== null &&
        key in queryPart &&
        (queryPart as Record<string, unknown>)[key] === value,
    ),
  );
};

/**
 * Invalidates queries that match specific filter criteria
 * @param queryClient - React Query client
 * @param baseQueryKey - Base query key to start from
 * @param filters - Object with filter key-value pairs to match
 */
export const invalidateQueriesByFilter = (
  queryClient: QueryClient,
  baseQueryKey: readonly unknown[],
  filters: Record<string, unknown>,
) => {
  queryClient.invalidateQueries({
    queryKey: baseQueryKey,
    predicate: (query) => hasQueryKeyFilter(query.queryKey, filters),
  });
};
